import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  CareerDescriptionBody,
  CareerDescriptionCard,
  CareerDescriptionHeader,
  CareerDescriptionHeaderIcon,
  CareerDescriptionHeaderText,
  CareerPrivacyNote,
} from '../styled'
import FileText from '../../assets/svgs/FileText'
import LockClosed from '../../assets/svgs/LockClosed'

export function JobDescription({ description, companyName }) {
  const { t } = useTranslation()

  return (
    <CareerDescriptionCard>
      <CareerDescriptionHeader>
        <CareerDescriptionHeaderIcon>
          <FileText width={16} height={16} color="currentColor" />
        </CareerDescriptionHeaderIcon>
        <CareerDescriptionHeaderText>
          {t('pages.jobDescription')}
        </CareerDescriptionHeaderText>
      </CareerDescriptionHeader>
      <CareerDescriptionBody
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <CareerPrivacyNote>
        <LockClosed width={14} height={14} />
        {companyName
          ? t('careers.applicationStaysPrivate', { company: companyName })
          : t('careers.applicationStaysPrivateGeneric')}
      </CareerPrivacyNote>
    </CareerDescriptionCard>
  )
}

JobDescription.propTypes = {
  description: PropTypes.string.isRequired,
  companyName: PropTypes.string,
}
